module.exports = __webpack_public_path__ + "img/4.8e09f849.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":609,"height":356,"variants":[{"file":"img/4-480w.e6ccecb11442.webp","width":480},{"file":"img/4-609w.5a653550f726.webp","width":609}]};
}